module.exports = "<div class=\"holder\" [@holder]=\"\">\n  <div class=\"aligner\">\n    <div class=\"inner\" fxLayout=\"row\" fxLayoutGap=\"80px\" fxLayoutAlign=\"center\">\n      <div class=\"header\" fxFlex=\"384px\">\n        <img class=\"logo\" src=\"assets/logo.svg\"/>\n      </div>\n      <div class=\"body\" fxFlex>\n        <home-nodes></home-nodes>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div class=\"server\">connected to {{backend.address}}</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home/home.component.html
// module id = ./src/app/components/home/home.component.html
// module chunks = main